module.exports = __webpack_public_path__ + "img/news3.7899503f.png";